import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { useIntl } from 'react-intl';

import { Dropdown, DropdownItem, DropdownMenu } from 'components/Dropdown2';
import { PFE_ICONS } from 'constants/icons';
import { schedulePropTypes } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import messages from './ScheduleDetailV2.messages';
import { useEditActionItems, useEmailActionItems } from './useActionItems';
import './MobileActionsOverflow.scss';

const { block, element } = bem('schedule-detail-v2-mobile-actions');

const MobileActionsOverflow = ({ schedule }) => {
  const intl = useIntl();
  const email = useEmailActionItems(schedule);
  const edit = useEditActionItems(schedule);

  if (!email.visible && !edit.visible) {
    return null;
  }

  const groups = [
    edit.items.filter(item => !item.danger),
    email.items.map(item => ({ ...item, disabled: email.frosted })),
    edit.items.filter(item => item.danger),
  ].filter(group => group.length > 0);

  return (
    <Dropdown className={block()} attachment="right" contentClassName={element('menu')}>
      {({ toggleMenu }) => (
        <>
          <button
            type="button"
            aria-label={intl.formatMessage(messages.actionsOverflowLabel)}
            className={element('toggle')}
            data-cypress="schedule-detail-v2-mobile-actions"
            onClick={toggleMenu}>
            <Isvg className={element('icon')} src={PFE_ICONS.optionsHorizontal} />
          </button>
          <DropdownMenu>
            {groups.flatMap((group, groupIndex) =>
              group.map((item, itemIndex) => (
                <DropdownItem
                  key={item.key}
                  className={element('item', {
                    danger: item.danger,
                    disabled: item.disabled,
                    'group-start': groupIndex > 0 && itemIndex === 0,
                  })}
                  disabled={item.disabled}
                  onClick={item.disabled ? undefined : item.onSelect}>
                  {item.label}
                </DropdownItem>
              ))
            )}
          </DropdownMenu>
        </>
      )}
    </Dropdown>
  );
};

MobileActionsOverflow.propTypes = {
  schedule: PropTypes.shape(schedulePropTypes),
};

export default MobileActionsOverflow;
